import React, { useCallback, useState } from 'react'

import { CarouselBanner as CitrusCarouselBanner } from '@interco/citrus-ads'

import { CarouselBanner } from '../CarouselBanner'
import type { SDUIComponentProps } from '../interfaces'

export const CitrusRenderer: React.FC<{ component: SDUIComponentProps }> = ({ component }) => {
  const [isShowCampaignBannerImg, setIsShowCampaignBannerImg] = useState(false)

  const handleCitrusCallback = useCallback((data: { campaigns: number }) => {
    setIsShowCampaignBannerImg(data.campaigns === 0)
  }, [])

  if (component?.props?.show !== 'enabled') return <></>

  const items = (component?.props?.items ?? []) as BannerComponent[]

  return (
    <>
      <div
        style={{
          marginTop: !isShowCampaignBannerImg ? component.style?.marginTop : '0',
          marginBottom: !isShowCampaignBannerImg ? component.style?.marginBottom : '0',
          padding: !isShowCampaignBannerImg ? '0 24px' : '0',
        }}
      >
        <CitrusCarouselBanner
          slotKey="HOME_CREDITO"
          data-testid="carousel-banner"
          onCallback={handleCitrusCallback}
        />
      </div>
      {isShowCampaignBannerImg && <CarouselBanner items={items} style={component.style} />}
    </>
  )
}
